import { React } from 'react';
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';

export default function PageNotFound() {
    return (
        <div>
            <Helmet>
                <title>404 - Novaetus</title>
            </Helmet>
            <div id="notfound">
                <div className="notfound">
                    <div className="notfound-404">
                        <img src="assets/images/logo.png" alt="Novaetus" width={150} />
                    </div>
                    <h2 className="text-white mb-3">404 - Page Not Found</h2>
                    <p className="text-white">The page you are looking for might have been removed, had its name changed or is temporarily unavailable.</p>
                    <Link to="/">Return Home</Link>
                </div>
            </div>
        </div>
    );
}